import React from 'react';
import { BrowseNavigationItemSelected, BrowseNavigationItemStyle } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { range } from '@udemy/shared-utils';
import { AcademiesNavItemType } from '../events';
import { useHeaderStore } from '../hooks/use-header-store';
import { MobileNavItem } from '../mobile/mobile-nav/mobile-nav.react-component';

/** Level key used for loading placeholder keys (l1 vs l2). */

/**
 * Shared logic and render helpers for career accelerators nav (used by both L1 and L2).
 * Returns click handler, single-item renderer, and list renderer so both nav levels can reuse them.
 */
export function useCareerAcceleratorsNavContent() {
  const headerStore = useHeaderStore();
  const handleAcademiesNavItemClick = React.useCallback(item => {
    var _item$slug;
    const context = {
      id: (_item$slug = item.slug) !== null && _item$slug !== void 0 ? _item$slug : String(item.id),
      style: BrowseNavigationItemStyle.NAVIGATION_DROPDOWN,
      type: item.type,
      relatedEntityType: AcademiesNavItemType.ALL_ACADEMIES,
      uiRegion: 'main_nav'
    };
    Tracker.publishEvent(new BrowseNavigationItemSelected(context));
  }, []);
  const renderAcademiesNavItem = React.useCallback(item => /*#__PURE__*/React.createElement(MobileNavItem, {
    onClick: () => handleAcademiesNavItemClick(item),
    key: `mobile-nav-academies-id-${item.id}`,
    href: item.absolute_url
  }, item.title), [handleAcademiesNavItemClick]);
  const renderAcademiesNavItemList = React.useCallback(levelKey => {
    const items = headerStore.userSpecificContext.careerAcceleratorsNav;
    return items && items.length ? items.map(item => renderAcademiesNavItem(item)) : range(6).map(i => /*#__PURE__*/React.createElement(MobileNavItem, {
      key: `${levelKey}-academies-id-${i}`,
      loading: true
    }));
  }, [headerStore.userSpecificContext.careerAcceleratorsNav, renderAcademiesNavItem]);
  return {
    renderAcademiesNavItemList
  };
}
//# sourceMappingURL=use-career-accelerator-nav-content.js.map